module.exports = __webpack_public_path__ + "static/media/whatsapp_new2.c69afd1b.svg";